import { createRoute } from "@tanstack/react-router";

import { renderProtectedRoute } from "@app/router/routeElements";
import { rootRoute } from "@app/router/rootRoute";
import { lazyWithRetry } from "@shared/lib/lazy";

const notificationsIndex = lazyWithRetry(() => import("./routes/index"));

const notificationsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/notifications",
  beforeLoad: () => ({
    breadcrumbs: [{ label: "Dashboard", to: "/" }, { label: "Notifications" }],
  }),
  component: () => renderProtectedRoute(notificationsIndex),
});

export const notificationsRouteTree = [notificationsIndexRoute];
